import React from 'react';
import Modal from 'react-bootstrap/Modal'
import { putRequest } from '../../http'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { ModI } from '../../components/modal_i.styled';
import { storage } from '../../firebase_config'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { z, ZodError} from 'zod'
import {v4 as uuidv4} from 'uuid'


export default function ModalItem(props) {
  

  const item = JSON.parse(localStorage.getItem('item'))
    
  
  
  const [file, setFile] = React.useState('')
  const [imgUrl, setImgUrl]= React.useState(item?.image_url)
  const [name, setName] = React.useState(item?.name)
  const [type, setType] = React.useState(item?.type)
  const [disc, setDisc] = React.useState(item?.description)
  const [errors, setErrors] = React.useState({})
  const [prize, setPrize] = React.useState(item?.price)
  const [category, setCategory] = React.useState(item?.category)
  const keys = Object.keys(errors)
  const [imgId, setImgId] = React.useState('')



  const subimgs ={
    Drinks: 'https://www.svgrepo.com/show/286022/drink-soda.svg',
    Food: 'https://www.svgrepo.com/show/415973/chef-food-hotel.svg',
    Tobacco: 'https://www.svgrepo.com/show/210379/smoker.svg',
    Bookings: 'https://www.svgrepo.com/show/26572/balloons.svg'

  }
    
  
    async function onImage(event) {
         
      setFile( event.target.files[0] )
      setImgId(`images/${uuidv4()}`)
  }
  
     const reader = new FileReader();
     reader.onload = ()=> {
        setImgUrl(reader.result) 
        
     }
     if (file) {
         reader.readAsDataURL(file);
     };
  
    
     async function addItem(event) {
       console.log(file)
       event.preventDefault()
       
       try {

        const itemValidater = z.object({
          type: z.string().min(2,{message: "This Field Is Required"}),
          name: z.string().min(2,{message: "This Field Is Required"}),
          description: z.string().min(2,{message: "This Field Is Required"}),
          category: z.string().min(2,{message: "This Field Is Required"}),
          prize: z.number().min(1,{message: "This Field Is Required"}),
          image_url: z.string().url()
          
         })
        itemValidater.parse({
          userId: localStorage.getItem('user'),
          name: name,
          type: type,
          description: disc,
          category: category,
          prize: prize,
          image_url: subimgs.Food
        })
        setErrors('none')
        const images = ref(storage, item.image_id )
        if (file) {
          await uploadBytes(images, file)
        }
        

       
        
        const url = file ? await getDownloadURL(images) : subimgs[type]
        
        const itemdata ={
          item_id: item._id,
          name: name,
          desc: disc,
          type: type,
          category: category,
          price: prize,
          image_url: url,
          
          
         }
        putRequest('/upd_item', itemdata, (resp)=>{
          console.log(resp.data)
        })
        console.log(url)
      
       } catch (error) {
        if (error instanceof ZodError){
          setErrors(error.flatten().fieldErrors)
        }else{
          console.log( error.message)
        }
        
       }
     }
  
    
    return (
      <div>
        
        <Modal
        onHide={()=>window.history.back()}
        show={true}
        backdrop='static'
        size='lg'
        aria-labelledby="contained-modal-title-vcenter"
        centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Update {name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <ModI>
            
          <div style={{textAlign: 'center', color: 'darkslategrey' }}><i>{file?.name}</i> </div>
            <div className="img">
            <div>
            <img src={imgUrl} alt=""  />
            </div>
            </div>
            <div className="choose">
            <Button variant='secondary' as='label' htmlFor="file" >
            Choose Image
            </Button>
             <input  style={{display: 'none'}} onChange={onImage}  type="file" accept='image/png, image/jpeg' name="file" id="file" />
            </div>
           
           
            
            <div className="fields">
            <div>
            <label htmlFor="">Name:</label>
            <Form.Control isInvalid={keys.includes('name')} isValid={keys.length === 0 ? false :!keys.includes('name')} onChange={(event)=>setName(event.target.value)} value={name} placeholder='Item Name' type="text"  />
            <Form.Control.Feedback className='err2' type='invalid'>{errors?.name?.at(0)}</Form.Control.Feedback>
            </div>
            <div>
            <label htmlFor="">Description:</label>
            <Form.Control isInvalid={keys.includes('description')} isValid={keys.length === 0 ? false :!keys.includes('description')} as={'textarea'} onChange={(event)=>setDisc(event.target.value)} value={disc} placeholder='Description' style={{marginBottom: '0px'}}  />
            <Form.Control.Feedback className='err2' type='invalid'>{errors?.description?.at(0)}</Form.Control.Feedback>
            </div>
            <div className="bott-end">
             <div style={{marginRight: '20px'}}><label htmlFor="">Prize:</label>
            <Form.Control isInvalid={keys.includes('prize')} isValid={keys.length === 0 ? false :!keys.includes('prize')} onChange={(event)=>setPrize(event.target.valueAsNumber)} value={prize} placeholder='Prize' type="number"  />
            <Form.Control.Feedback className='err2' type='invalid'>{errors?.prize?.at(0)}</Form.Control.Feedback>
            </div>
            <div>
            <label htmlFor="">Item Type</label>
            <Form.Select as='select' isInvalid={keys.includes('type')} isValid={keys.length === 0 ? false :!keys.includes('type')} onChange={(event)=>setType(event.target.value)} value={type} >
              <option value="">Category</option>
              <option value="Food">Food</option>
              <option value="Drinks">Drinks</option>
              <option value="Tobacco">Tobacco</option>
              <option value="Bookings">Bookings</option>
            </Form.Select>
            <Form.Control.Feedback className='err2' type='invalid'>{errors?.category?.at(0)}</Form.Control.Feedback>
            </div>
            </div>
            <div>
              <label htmlFor="">Category:</label>
              <Form.Control isInvalid={keys.includes('category')} isValid={keys.length === 0 ? false :!keys.includes('category')} onChange={(event)=>setCategory(event.target.value)} value={category} placeholder='Category' type="text"  />
              <Form.Control.Feedback className='err2' type='invalid'>{errors?.name?.at(0)}</Form.Control.Feedback>
            </div>
            </div>
            <div className="btns">
            
            <Button variant='success' onClick={addItem} style={{marginLeft: '16px'}} >Update</Button>
          </div>
          </ModI>
          </Modal.Body>

        </Modal>
      </div>
    );
}